import { formatDate, formatNumber } from 'devextreme/localization';
import { useContext, useState, } from 'react';
import { useGetCompany } from '../../../../api/company';
import { LoadPagePanel } from '../../../../components';
import { useAuth } from '../../../../contexts/auth';
import { Field, Panel } from '../../../../layouts';
import { BusinessFlow, OrderStatus } from '../../../../types/enums';
import { useGetRetailOrder } from '../api/get-retail-order';
import { RetailOrderContext } from '../context/RetailOrderContext';
import ChangeRequestPopup from './ChangeRequestPopup';

export default function RetailOrderInformationPanel() {

	const { user } = useAuth();
	const { order } = useContext(RetailOrderContext);
	const userCompany = useGetCompany(user?.companyId);
	const [isPopupVisible, setPopupVisibility] = useState(false);

	const initialRetailOrder = useGetRetailOrder(isPopupVisible ? order.details.initialRetailOrderID : undefined);

	return (
		<>
			<Panel
				header={'Retail Order Information'}
				className="field-label-35"
			>
				<Field label={'Order #'} >
					{order.details.roNumber}
				</Field>
				<Field label={'Order Type'} >
					{order.details.roType}
				</Field>
				<Field label={'Dealer Cost'} visible={userCompany.data?.businessFlowID === BusinessFlow.Lowes || userCompany.data?.isParent}>
					{
						!!order.details.initialRetailOrderID && userCompany.data?.isParent ?
							<a onClick={() => setPopupVisibility(true)}>
								{formatNumber(order.details.amount, { type: 'currency', precision: 2 })}
							</a>
							:
							<>
								{formatNumber(order.details.amount, { type: 'currency', precision: 2 })}
							</>
					}
				</Field>
				<Field label={'Dealer Retail'} visible={userCompany.data?.businessFlowID !== BusinessFlow.Lowes}>
					{formatNumber(order.details.retailAmount, { type: 'currency', precision: 2 })}
				</Field>
				<Field label={'Order Status'} >
					{order.details.orderStatus}
				</Field>
				<Field label={'Hold Reason'} visible={order.details.orderStatusID === OrderStatus.Hold}>
					{order.details.holdReason}
				</Field>
				<Field label={'Order Date'} >
					{formatDate(new Date(order.details.roDate), 'shortDate')}
				</Field>
				<Field label={'RO Creation Date'} >
					{formatDate(new Date(order.details.createdOn), 'shortDate')}
				</Field>
				<Field label={'Estimate	#'} visible={userCompany.data?.businessFlowID !== BusinessFlow.Lowes}>
					{order.details.quoteNumber}
				</Field>
				<Field label={'Project #'} >
					{order.details.projectNumber}
				</Field>
			</Panel>
			{
				isPopupVisible && initialRetailOrder.data &&
				<ChangeRequestPopup
					title="Dealer Cost"
					orderDetails={initialRetailOrder.data}
					onHidePopup={() => setPopupVisibility(false)}
				/>
			}
			<LoadPagePanel visible={initialRetailOrder.isLoading} />
		</>
	);
}
